import Image from '@/components/app-image';
import { AgentLogo } from './agent-logo';

export function AgentAvatar({
  avatar,
  name,
  agentId,
  className = 'size-7',
}: {
  avatar?: string;
  name: string;
  agentId: string;
  className?: string;
}) {
  return avatar ? (
    <Image
      src={avatar}
      alt={name}
      width={64}
      height={64}
      className={`${className} rounded-full object-cover`}
    />
  ) : (
    <AgentLogo id={agentId} name={name} className={className} />
  );
}
